import React from 'react';
import { Book, FileText, MessageCircleQuestion, BrainCircuit } from 'lucide-react';
import { cropStyle } from '../common/ImageCropModal';

const TYPE_ICON = { book: Book, note: FileText, exercise: MessageCircleQuestion, quiz: BrainCircuit };

const TYPE_TONE = {
  book: 'bg-emerald-500/10 text-emerald-500',
  note: 'bg-blue-500/10 text-blue-500',
  quiz: 'bg-purple-500/10 text-purple-500',
  exercise: 'bg-amber-500/10 text-amber-500',
};

// Fills its parent (which must be positioned) with either the uploader's
// cover image, framed exactly as they cropped it, or the type icon when
// there's no cover.
const MaterialCover = ({ item, iconSize = 36, hover = false, fallbackClassName }) => {
  const type = String(item.type || item.category || 'note').toLowerCase();

  if (item.cover_url) {
    return (
      <img
        src={item.cover_url}
        alt=""
        loading="lazy"
        className={`absolute inset-0 transition-transform duration-700 ${hover ? 'group-hover:scale-105' : ''}`}
        style={cropStyle(item.cover_crop)}
      />
    );
  }

  const Icon = TYPE_ICON[type] || FileText;
  return (
    <div className={`absolute inset-0 flex items-center justify-center ${fallbackClassName || TYPE_TONE[type] || 'bg-muted text-muted-foreground'}`}>
      <Icon
        size={iconSize}
        className={`transition-transform duration-700 ${hover ? 'group-hover:scale-110 group-hover:rotate-3' : ''}`}
      />
    </div>
  );
};

export default MaterialCover;
